import moment from 'moment';

export interface ICronTimestamp {
  TCA: number;
  airport_delays: number;
  pireps: number;
  radar: number;
  rwy_in_use: number;
  sigmet: number;
  traffic: number;
  turbulence: number;
  weather: number;
  wind: number;
  VAA: number;
}

const getStatus = (
  key: keyof ICronTimestamp,
  timestamp: number
): {
  status: string; // current or stale
  message: string;
} => {
  const now = moment().unix();
  const diff = now - timestamp;
  switch (key) {
    case 'traffic': {
      let status = 'stale';
      if (diff < 15 * 60) {
        status = 'current';
      }
      return {
        status,
        message: `Last updated at: ${moment.unix(timestamp).fromNow()} ago`
      };
    }
    case 'weather':
    case 'wind': {
      let status = 'stale';
      if (diff < 7 * 24 * 60 * 60) {
        status = 'current';
      }
      return {
        status,
        message: `Effective until: ${moment
          .unix(timestamp)
          .format('DD/MM HH:mm')}`
      };
    }
    case 'turbulence': {
      let status = 'stale';
      if (diff < 24 * 60 * 60) {
        status = 'current';
      }
      return {
        status,
        message: `Effective until: ${moment
          .unix(timestamp)
          .format('DD/MM HH:mm')}`
      };
    }
    case 'TCA':
    case 'sigmet':
    case 'radar': {
      let status = 'stale';
      if (diff < 12 * 60 * 60) {
        status = 'current';
      }
      return {
        status,
        message: `Effective until: ${moment
          .unix(timestamp)
          .format('DD/MM HH:mm')}`
      };
    }
    default:
      return {
        status: 'stale',
        message: ''
      };
  }
};

export const generateDataStatus = (data: ICronTimestamp) => {
  const temp = [
    {
      name: 'Traffic',
      key: 'traffic' as keyof ICronTimestamp,
      source: 'ADS-B',
      ...getStatus('traffic', data?.traffic),
      type: 'primary'
    },
    {
      name: 'Weather',
      key: 'weather' as keyof ICronTimestamp,
      source: 'OpenWeatherMap',
      ...getStatus('weather', data?.weather)
    },
    {
      name: 'Wind',
      key: 'wind' as keyof ICronTimestamp,
      source: 'NOAA',
      ...getStatus('wind', data?.wind),
      type: 'primary'
    },
    {
      name: 'Volcanic Ash',
      key: 'radar' as keyof ICronTimestamp,
      source: 'National Oceanic and Atmospheric Administration',
      ...getStatus('radar', data?.radar),
      type: 'primary'
    },
    {
      name: 'Tropical Cyclone',
      key: 'TCA' as keyof ICronTimestamp,
      source: 'Joint Typhoon Warning Center',
      ...getStatus('TCA', data?.TCA),
      type: 'primary'
    },
    {
      name: 'Turbulence',
      key: 'turbulence' as keyof ICronTimestamp,
      source: 'National Oceanic and Atmospheric Administration',
      ...getStatus('turbulence', data?.turbulence),
      type: 'primary'
    },
    {
      name: 'SIGMET',
      key: 'sigmet' as keyof ICronTimestamp,
      source: 'Aviation Weather Center',
      ...getStatus('sigmet', data?.sigmet),
      type: 'primary'
    }
  ];
  return temp;
};
